import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Drawer, Box, Divider} from 'views/components';

import NavbarLogo from './navbar_top/NavbarLogo';
import NavbarServices from './navbar_services/NavbarServices';
import NavbarUser from './navbar_top/NavbarUser';
import NavbarAccount from './navbar_top/NavbarAccount';

const NavBar = (props) => {
  const {
    account,
    setAccount,
  } = props;

  return (
    <Drawer
      sx={{
        'width': 240,
        'flexShrink': 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
      PaperProps={{
        sx: {
          backgroundColor: 'navbar.main',
        },
      }}
      open={true}
      variant="permanent"
      anchor="left"
    >
      <Box sx={{
        my: 2,
        ml: 2,

        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}>
        <NavbarLogo />
      </Box>
      <Box sx={{
        my: 1,
        mx: 2,
      }}>
        <NavbarUser />
        <NavbarAccount account={account} setAccount={setAccount} />
      </Box>
      <Divider sx={{borderColor: 'grey.400'}}/>
      <Box sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
      }}>
        <NavbarServices account={account} />
      </Box>
    </Drawer>
  );
};

NavBar.propTypes = {
  account: PropTypes.oneOf(['care', 'recruiter', 'ops']).isRequired,
  setAccount: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
